<template>
	<div class="mapClass" :style="{zoom: zoomNum}">
		<img :src="mapUrl" class="mapImg_li" @load="imgSuccess">
		<div id="mapBack" style="position: absolute;width: 100%;height: 100%;">
			<div v-for="(objl, index) in lineList" :key="'lines' + index" class="linesClass"
				:style="{left: objl.left + 'px', top: objl.top + 'px', width: objl.width + 'px','transform-origin': `0 0`,'-webkit-transform': `rotate(${objl.rotate}deg)`}">
			</div>
		</div>
		<div id="aaa_li" class="mapPostion_li" v-show="ifDraw" :style="{'transform': `scale(${1/zoomNum})`}">
			<div class="circle_bottom animation"></div>
		</div>
	</div>
</template>

<script>
	import {
		positonInfo,
		robotRouteByRobotId
	} from '@/api/user'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				dialogClose: require('../../static/img/close.png'),
				robotSrc: require('../../static/img/xyRobot.png'),
				mapUrl: '',
				robotId: '',
				zoomNum: 0,
				lineList: [],
				ifDraw: false
			}
		},
		props: {
			position: {},
			posInfo: {},
			autoHeight: Number,
			autoWidth: Number
		},
		mounted() {
			let that = this
			this.getPosDetail(that.position)
		},
		methods: {
			getPosDetail(res) {
				let that = this
				that.robotId = res.robotId
				positonInfo({
					robotId: res.robotId,
					userId: getItem('userInfo').staffId
				}).then(res => {
					that.mapUrl = res.data.address
					let vDom = document.getElementById('aaa_li')
					let mapImgDom = document.getElementsByClassName('mapClass')[0]
					let vDomZoomW = document.documentElement.clientWidth * 0.7
					let vDomZoomH = document.documentElement.scrollHeight * 0.8
					mapImgDom.style.width = res.data.width + 'px'
					mapImgDom.style.height = res.data.height + 'px'
					mapImgDom.style.margin = "0 auto"
					if (Number(res.data.width) > Number(res.data.height)) {
						mapImgDom.style.zoom = vDomZoomW / Number(res.data.width)
					} else {
						mapImgDom.style.zoom = vDomZoomH / Number(res.data.height)
					}
					that.countZoom()
				})
			},
			imgSuccess() {
				this.robotRouteByRobotId(this.robotId)
				this.ifDraw = true
			},
			countZoom() {
				let that = this
				let mapImgDom = document.getElementsByClassName('mapClass')[0]
				if (mapImgDom.offsetHeight > mapImgDom.offsetWidth) {
					that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
				} else {
					if ((that.autoWidth / that.autoHeight) > (mapImgDom.offsetWidth / mapImgDom.offsetHeight)) {
						that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
					} else {
						that.zoomNum = that.autoWidth / mapImgDom.offsetWidth
					}
				}
			},
			robotRouteByRobotId(id) {
				let that = this
				robotRouteByRobotId(id).then(res => {
					if (res.data && res.data.coords) {
						let drawList = []
						res.data.coords.split(";").map(v => {
							drawList.push({
								x: Number(v.split(",")[0]),
								y: Number(v.split(",")[1])
							})
						})
						that.drawLine(drawList)
					}
				})
			},
			drawLine(drawList) {
				let that = this
				let dr_Len = drawList.length
				if (dr_Len > 1) {
					for (var i = 0; i < drawList.length; i++) {
						if (i < drawList.length - 1) {
							let cWidth = that.calculationWidth({
								x1: drawList[i].x,
								y1: drawList[i].y,
								x2: drawList[i + 1].x,
								y2: drawList[i + 1].y
							})
							let cRotate = that.calculationRotate({
								x1: drawList[i].x,
								y1: drawList[i].y,
								x2: drawList[i + 1].x,
								y2: drawList[i + 1].y
							})
							that.lineList.push({
								width: cWidth,
								rotate: cRotate - 180,
								top: drawList[i].y,
								left: drawList[i].x,
							})
						}
					}
				}
			},
			// 计算长度
			calculationWidth(xy) {
				return Math.sqrt((xy.x2 - xy.x1) * (xy.x2 - xy.x1) + (xy.y2 - xy.y1) * (xy.y2 - xy.y1));
			},
			// 计算角度
			calculationRotate(xy) {
				let radian = Math.atan2(xy.y1 - xy.y2, xy.x1 - xy.x2);
				let angle = 180 / Math.PI * radian;
				return angle;
			},
			closeMap() {
				this.$emit('closeRobot', true)
			}
		},
		destroyed() {
			// 关闭
		},
		watch: {
			posInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.$nextTick(() => {
						let vDom = document.getElementById('aaa_li')
						if (newValue.positon && that.robotId === newValue.robotId) {
							vDom.style.left = Number(newValue.positon.split(',')[0]) - 10 + 'px'
							vDom.style.top = Number(newValue.positon.split(',')[1]) - 10 + 'px'
							vDom.style.opacity = '1'
						}
					})
				}
			},
			autoHeight: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$nextTick(() => {
							let mapImgDom = document.getElementsByClassName('mapClass')[0]
							if (mapImgDom.offsetHeight > mapImgDom.offsetWidth) {
								that.zoomNum = newValue / mapImgDom.offsetHeight
							}
						})
					}
				}
			},
			autoWidth: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					if (newValue) {
						that.$nextTick(() => {
							let mapImgDom = document.getElementsByClassName('mapClass')[0]
							if (mapImgDom.offsetWidth >= mapImgDom.offsetHeight) {
								if ((newValue / that.autoHeight) > (mapImgDom.offsetWidth / mapImgDom
									.offsetHeight)) {
									that.zoomNum = that.autoHeight / mapImgDom.offsetHeight
								} else {
									that.zoomNum = newValue / mapImgDom.offsetWidth
								}
								// that.zoomNum = newValue/mapImgDom.offsetWidth
							}
						})
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@keyframes icon {
		0% {
			transform: translate(0, 0)
		}

		50% {
			transform: translate(0px, -10px)
		}

		100% {
			transform: translate(0, 0)
		}
	}

	.pointClass {
		width: 3px;
		height: 3px;
		background-color: black;
		border-radius: 50%;
		position: absolute;
	}

	.linesClass {
		position: absolute;
		height: 1px;
		border-top: 2px solid red;
	}

	#aaa {
		// position: absolute;
		// width: 10px;
		// height: 10px;
		// left: 0px;
		// top: 0px;
		// background-color: blue;
		// border-radius: 50%;
		// transition: all .8s;
	}

	.mapClass {
		position: relative;
	}

	.mapImg_li {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.mapClose {
		position: absolute;
		width: 30px;
		height: 30px;
		top: -15px;
		right: -15px;
		cursor: pointer;
	}

	.mapPostion_li {
		border-radius: 50%;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;

		.circle_bottom {
			background: #FF0000; /* 红色 */
			border-radius: 100%;
			filter: alpha(opacity=40);
			z-index: -100;
			box-shadow: 0px 0px 4px 2px rgba(255, 0, 0, 0.5); /* 阴影再缩小一点 */
			position: absolute;
			width: 6px;  /* 从7px缩小到6px */
			height: 6px; /* 从7px缩小到6px */
		}
		.animation {
			-webkit-animation: twinkling 2.1s infinite ease-in-out;
			animation: twinkling 2.1s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		@-webkit-keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 4px 2px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.12);
				background-color: #FF3333;
				box-shadow: 0px 0px 6px 4px rgba(255, 0, 0, 0.8);
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 4px 2px rgba(255, 0, 0, 0.6);
			}
		}

		@keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 4px 2px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.12);
				background-color: #FF3333;
				box-shadow: 0px 0px 6px 4px rgba(255, 0, 0, 0.8);
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 4px 2px rgba(255, 0, 0, 0.6);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/RobotMapLi.vue